import React from 'react';
import { Box } from '@zillow/constellation';
import CalculatorLayout from '../CalculatorLayout/CalculatorLayout.js';
import CalculatorForm from '../CalculatorForm/CalculatorForm.js';
import { isEditor } from '../../utils/isEditor.js';
import HomeSaleProceedsFields from './HomeSaleProceedsFields.js';
import HomeSaleProceedsContent from './HomeSaleProceedsContent.js';
import { omitUndefined } from '../../utils/lodash.js';
import { FieldConfig } from './HomeSaleProceedsCalculator.utils.js';

var _DEFAULT_VALUES;
var DEFAULT_VALUES = (_DEFAULT_VALUES = {}, _DEFAULT_VALUES[FieldConfig.desiredSellingPrice.name] = 302000, _DEFAULT_VALUES[FieldConfig.remainingMortgageOwed.name] = 0, _DEFAULT_VALUES[FieldConfig.homeImprovement.name] = 0, _DEFAULT_VALUES[FieldConfig.cleaningAndPrep.name] = 6000, _DEFAULT_VALUES[FieldConfig.monthlyMortgagePayments.name] = 0, _DEFAULT_VALUES[FieldConfig.moving.name] = 500, _DEFAULT_VALUES[FieldConfig.agentCommission.name] = 18120, _DEFAULT_VALUES[FieldConfig.sellingConcessions.name] = 3020, _DEFAULT_VALUES[FieldConfig.closingFees.name] = 1510, _DEFAULT_VALUES[FieldConfig.taxes.name] = 3020, _DEFAULT_VALUES);
var HomeSaleProceedsCalculator = function HomeSaleProceedsCalculator(_ref) {
  var defaultValues = _ref.defaultValues;
  var mergedValues = Object.assign({}, DEFAULT_VALUES, omitUndefined(defaultValues));
  return /*#__PURE__*/React.createElement(CalculatorForm, {
    fieldStorageKey: "closingCostFields",
    editorMode: isEditor(),
    defaultValues: mergedValues
  }, /*#__PURE__*/React.createElement(Box, {
    as: CalculatorLayout,
    sxOverride: {
      '@media $sm_lte': {
        flexDirection: 'column-reverse'
      }
    },
    fields: /*#__PURE__*/React.createElement(HomeSaleProceedsFields, null),
    content: /*#__PURE__*/React.createElement(HomeSaleProceedsContent, null)
  }));
};
var HomeSaleProceedsCalculator$1 = HomeSaleProceedsCalculator;

export { HomeSaleProceedsCalculator$1 as default };
